import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Firebase
import { firebaseApp } from './firebase'
import { getAnalytics } from 'firebase/analytics'
import { VueFire } from 'vuefire'

if (typeof window !== 'undefined') {
    getAnalytics(firebaseApp);
}

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faCircleQuestion, faCircle as faCircleReg, faSquare as faSquareReg } from '@fortawesome/free-regular-svg-icons'
import { faShuffle, faCircle, faSquare, faChartSimple, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(faCircleQuestion, faShuffle, faCircle, faCircleReg, faSquare, faSquareReg, faChartSimple, faCircleCheck)

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
// Import Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


createApp(App)
    .use(router)
    .use(VueFire, { firebaseApp})
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
